// LOGOMAN PRO — generate tagline suggestions per industry.
// Template-driven (no API), but the templates are written in the voice of
// strong brand copy. Easy to swap with Claude API later.

const TEMPLATES: Record<string, string[]> = {
  tech: [
    "{name} — built for what's next.",
    "Software that just works.",
    "Engineered for speed.",
    "Where ideas ship.",
    "Future-proof by design.",
    "{name}: code meets craft.",
  ],
  health: [
    "Care that listens.",
    "Your health, on your terms.",
    "Wellness, simplified.",
    "{name} — better days, every day.",
    "Heal, grow, thrive.",
    "Modern care for modern life.",
  ],
  food: [
    "Made with intention.",
    "Real food, real flavor.",
    "{name} — taste the difference.",
    "From our kitchen to yours.",
    "Honest ingredients, honest craft.",
    "Fresh. Local. {name}.",
  ],
  beauty: [
    "Where confidence begins.",
    "Beauty, your way.",
    "{name} — defined by you.",
    "Glow on.",
    "Crafted to flatter.",
    "Looks that last.",
  ],
  finance: [
    "Wealth, made simple.",
    "{name} — your money, mastered.",
    "Smart finance, smart future.",
    "Plan with confidence.",
    "Built on trust.",
    "Where strategy meets growth.",
  ],
  fitness: [
    "Stronger every day.",
    "{name} — train your edge.",
    "Move. Lift. Win.",
    "Where limits end.",
    "Built for the grind.",
    "Sweat is the receipt.",
  ],
  retail: [
    "{name} — picked for you.",
    "Goods worth keeping.",
    "Shop the difference.",
    "Made to be loved.",
    "Curated, never compromised.",
    "Quality you'll feel.",
  ],
  "real-estate": [
    "Find home faster.",
    "{name} — keys to your next chapter.",
    "Properties with potential.",
    "Where you'll want to live.",
    "Real estate, reimagined.",
    "Move with confidence.",
  ],
  education: [
    "{name} — learn out loud.",
    "Knowledge, accessible.",
    "Every learner, every level.",
    "Where curiosity meets craft.",
    "Education that opens doors.",
    "Master what matters.",
  ],
  creative: [
    "{name} — design with intent.",
    "Brave ideas, beautiful work.",
    "Where creativity ships.",
    "Crafted to be noticed.",
    "Make something that lasts.",
    "Visual stories, well told.",
  ],
  consulting: [
    "Strategy that scales.",
    "{name} — clarity for complexity.",
    "Where insight drives growth.",
    "Outcomes over opinions.",
    "Smart counsel. Real results.",
    "We make the hard easy.",
  ],
  travel: [
    "{name} — go further, easier.",
    "Adventures, curated.",
    "Where the journey begins.",
    "Travel made personal.",
    "See the world differently.",
    "Wander with purpose.",
  ],
  pets: [
    "{name} — for the animals we love.",
    "Tails wag here.",
    "Care that comes home with them.",
    "Premium for your pup.",
    "Built for the bond.",
    "Happy pets, happy people.",
  ],
  photo: [
    "Moments that last.",
    "{name} — light, captured.",
    "Stories told in stills.",
    "Frames worth framing.",
    "Where memory meets craft.",
    "See it. Feel it. Keep it.",
  ],
  auto: [
    "{name} — built to move.",
    "Drive bolder.",
    "Performance, refined.",
    "Where engineering meets soul.",
    "Roads less travelled.",
    "Tuned for the road ahead.",
  ],
  other: [
    "{name} — made with care.",
    "Built different.",
    "Where details matter.",
    "Quality, by design.",
    "Born from craft.",
    "{name}. Done right.",
  ],
};

export function suggestSlogans(industry: string | null, brandName: string, count = 6): string[] {
  const pool = (industry && TEMPLATES[industry]) || TEMPLATES.other;
  // Fisher-Yates shuffle a copy
  const arr = [...pool];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  const name = brandName.trim() || "Your Brand";
  return arr.slice(0, count).map((t) => t.replace(/\{name\}/g, name));
}
